/**
 * @generated SignedSource<<122c1d13430b40df93b3f0e0be2adb21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PremiumDeleteConfirmButton_premium$data = {
  readonly id: string;
  readonly " $fragmentType": "PremiumDeleteConfirmButton_premium";
};
export type PremiumDeleteConfirmButton_premium$key = {
  readonly " $data"?: PremiumDeleteConfirmButton_premium$data;
  readonly " $fragmentSpreads": FragmentRefs<"PremiumDeleteConfirmButton_premium">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PremiumDeleteConfirmButton_premium",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "MATPremiumApplyHistory",
  "abstractKey": null
};

(node as any).hash = "28a94c6857b96bae16f5ecf02e0e7ada";

export default node;
